var render, staticRenderFns
import script from "./SuijinChart.vue?vue&type=script&lang=js&"
export * from "./SuijinChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9ca59f",
  null
  
)

export default component.exports